<template>
  <div>
    <div class="header">
      <div class="main-header">
        <div class="header-left">
          <template v-for="i in logoList">
            <a :href="i.href" target="_blank" :key="i.id"><img alt=""  :src="i.src"></a>
          </template>
        </div>
        <div class="header-right">
          <template v-for="i in rightArr">
            <div :class="[(i.id === id && isOpen || $route.fullPath === i.url) ? 'button active' : 'button']" :key="i.id"  v-if="$route.fullPath === '/register' && i.url !== ''"  @click="jumpClick(i.id, i.url)">
            <span>{{$route.fullPath === i.url ? '返回首页' : i.title}}</span>
            </div>
            <div :class="[(i.id === id && isOpen || $route.fullPath === i.url) ? 'button active' : 'button']" :key="i.id"  v-if="$route.fullPath !== '/register'"  @click="jumpClick(i.id, i.url)">
            <span>{{$route.fullPath === i.url ? '返回首页' : i.title}}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <login-dialog :isOpen.sync="isOpen" @openChange="openChange"></login-dialog>
  </div>
</template>
<script>
import loginDialog from '@/components/before/home/centerDialog';
import { ISEND } from "@/js/public";
export default {
  name: 'indexHeader',
  components: {
    'login-dialog': loginDialog
  },
  data () {
    return {
      title: '登&nbsp;&nbsp;录',
      isOpen: false,
      logoList: [
        {
          id: 1,
          src: require('../assets/img/ztxh.png'),
          href: 'https://www.lsc.org.cn/cns/html_pass/index.html'
        },
        {
          id: 2,
          src: require('../assets/image2025/hagongda.png'),
          href: 'http://www.lib.hit.edu.cn/'
        },
        {
          id: 3,
          src: require('../assets/img/readerstar.png'),
          href: 'http://www.readerstar.com/'
        },
        {
          id: 4,
          src: require('../assets/image2025/chengyi.png'),
          href: 'https://www.chengyiart.cn/'
        }
      ],
      rightArr: [
        // {
        //  id: 1,
        //  title: '报名注册',
        //  url: '/register'
        // },
        {
          id: 2,
          title: '登录',
          url: ''
        },
        {
          id: 3,
          title: '报名查询',
          url: '/search'
        },
        {
          id: 4,
          title: '结果公布',
          url: '/results'
        }
        // {
        //   id: 5,
        //   title: '帮助',
        //   url: '/results'
        // }
      ],
      id: 0
    }
  },
  methods: {
    openModal () {
      this.isOpen = true
    },
    openChange (v) {
      if (!v) {
        this.isOpen = false
      }
    },
    jumpClick (id, url) {
      this.id = id
      if (this.$route.fullPath === url) {
        this.$router.replace('/')
        return
      }
      if (url) {
        // console.log(url);
        this.$router.push(`${url}`)
      } else {
        this.isOpen = true
      }
    }
  },
  computed: {
    rightList () {
      return ISEND ? this.rightArr : this.rightArr.filter(i => i.id !== 1)
    }
  }
}
</script>
<style lang="scss" scoped>
  .header-left{
    margin-left: 8%;
    a{
      &:nth-child(2){
        img{
        height: 51px !important;
      }
      }
    }
  }
  .header {
    width: 100%;
    height: 9rem;
    background-color: transparent;
    background-color: rgba(0,0,0,0.5);
    top: 0;
    left: 0;
    z-index: 9;

  }
  .main-header {
    // width: 1200px;
    // margin-left: 220px !important;
    // margin-right: 1px !important;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-left a img {
      margin-right: 2.5rem;
      height: 43px;
    }
    .header-right {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 18%;
      .button {
        width: 10rem;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.8rem;
        color: #fff;
        border: 1px transparent solid;
        border-image: linear-gradient(to bottom, transparent, #5096f6) 1 10;
        &:hover {
          background: linear-gradient(to bottom, transparent, #5096f6);
          //border: 1px solid red;
        }
        span {
          cursor: pointer;
        }
      }
      .active {
        background: linear-gradient(to bottom, transparent, #5096f6);
        //border: 1px solid red;
      }
    }
  }
  @media screen and (max-width: 1280px){
  .main-header {
    margin-left: 20px !important;
  }
}
</style>
